// Buttons
/**
 * @deprecated Please use NewButtonColour instead
 */
export enum ButtonColour { // TODO: Legacy, remove this when resource is available
  primary = 'legacy_primary',
  secondary = 'legacy_secondary',
  secondaryColour = 'legacy_secondary-colour',
  secondaryGhost = 'legacy_secondary-ghost',
}

export enum NewButtonColour { // TODO: Rename this to ButtonColour when resource is available
  Danger = 'Danger',
  Ghost = 'Ghost',
  Link = 'Link',
  Outline = 'Outline',
  PrimaryNavy = 'PrimaryNavy',
  PrimaryLilac = 'PrimaryLilac',
  PrimarySalmon = 'PrimarySalmon',
  PrimaryTeal = 'PrimaryTeal',
  PrimarySpecial = 'PrimarySpecial',
  Subtle = 'Subtle',
  Success = 'Success',
  Transparent = 'Transparent',
}
export type NewButtonColourType = keyof typeof NewButtonColour;

// NOTE: Keep these in sync
export type SelectColour = NewButtonColour.Outline | NewButtonColour.Ghost;
export const selectColours: SelectColour[] = [NewButtonColour.Outline, NewButtonColour.Ghost];

export enum ButtonSize {
  extraSmall = 'extraSmall',
  small = 'small',
  mediumLegacy = 'mediumLegacy', // NOTE: Legacy to support 36px height, i.e. our existing inputs
  medium = 'medium',
  large = 'large',
  // Icon sizes
  iconSmall = 'iconSmall',
  iconLarge = 'iconLarge',
  iconOnly = 'iconOnly',
}

// Selects
export enum SelectMenuPosition {
  BottomRight = 'bottomRight',
  BottomLeft = 'bottomLeft',
  TopRight = 'topRight',
  TopLeft = 'topLeft',
}
